import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../../utils/constants';
import { signInAPi } from '../../../api/user';
import Logo from '../../../assets/images/logo-1.png';
import { errorModal, warningModal } from '../../Alerts/Alerts';

import "../../../assets/css/login.css";

export default function LoginForm() {
    const [inputs, setInputs] = useState({
        nm_correo: "",
        nm_password: ""
    });

    const changeForm = e => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        });
    };

    const login = async e => {
        e.preventDefault();

        if(inputs.nm_correo && inputs.nm_password){
            let result = await signInAPi(inputs);
            if (result.message) {
                errorModal	("Error", result.message);
            } else {
                const { accessToken, refreshToken } = result;
                localStorage.setItem(ACCESS_TOKEN, accessToken);
                localStorage.setItem(REFRESH_TOKEN, refreshToken);
                window.location.href = "/admin";
            }
        }else{
            if(inputs.nm_correo ==="" || inputs.nm_password === ""){
                warningModal("Advertencia", "Debe ingresar correo y contraseña.");
                return;
            }
        }
    };

    return (
        <div id="login-form" className="cart p-3 position-absolute">
            <div className="cart-body">

                <Form className="form-signin tile" onChange={changeForm}>
                    <Form.Group className="col text-center mb-5">
                        <img className="text-center" src={Logo} width="250" alt="" />
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail">
                        <Form.Label className=" mt-0">Ingrese su Correo</Form.Label>
                        <Form.Control type="email" placeholder="Ingresar Correo" name="nm_correo" className="form-control" />
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword">
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control type="password" placeholder="**********" name="nm_password" className="form-control" />
                    </Form.Group>
                    <div className="row mt-4">
                        <div className="col text-center">
                            <Button variant="primary" type="submit" className="btn btn-lg btn-primary col-10 btn-block m-auto" onClick={login}>
                                Iniciar Sesión
                            </Button>
                        </div>
                    </div> 
                </Form>
            </div>
        </div>
    )
}